import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import Login from '../pages/Admin/Login'
import Index from '../pages/Index'
import Member from '../pages/Member'

import Archive from '../pages/Archive'
import Outside from '../pages/Outside'
import Product from '../pages/Product'
import Exam from '../pages/Exam'
import Mortgage from '../pages/Mortgage'

import Applet from '../pages/Applet'
import Activity from '../pages/Activity'
import Finance from '../pages/Finance'
 
import Questions from '../pages/Questions'

import System from '../pages/System'
import Website from '../pages/Website'


const Chart = lazy(()=>import('../pages/Index/Chart'))
// const New = lazy(()=>import('../pages/Index/New'))
// const Tian = lazy(()=>import('../pages/Index/Tian'))

const Client = lazy(()=>import('../pages/Member/Client'))
const Calculate = lazy(()=>import('../pages/Member/Calculate'))
const Calculates = lazy(()=>import('../pages/Member/Calculates'))
const Confirm = lazy(()=>import('../pages/Member/Confirm'))
const Information = lazy(()=>import('../pages/Member/Information'))
const Rakeback = lazy(()=>import('../pages/Member/Rakeback'))
const Proofs = lazy(()=>import('../pages/Member/Proofs'))



const Userlist = lazy(()=>import('../pages/Archive/Userlist'))
const Integral = lazy(()=>import('../pages/Archive/Integral'))


const OutsideUser = lazy(()=>import('../pages/Outside/User'))
const OutsideClient = lazy(()=>import('../pages/Outside/Client'))


const Bank = lazy(()=>import('../pages/Product/Bank'))
const ProductList = lazy(()=>import('../pages/Product/Product'))
const Channel = lazy(()=>import('../pages/Product/Channel'))
const Source = lazy(()=>import('../pages/Product/Source'))


const Question = lazy(()=>import('../pages/Exam/Question'))
const Paper = lazy(()=>import('../pages/Exam/Paper'))
const Reference = lazy(()=>import('../pages/Exam/Reference'))

const MortgageUser = lazy(()=>import('../pages/Mortgage/User'))
const MortgageList = lazy(()=>import('../pages/Mortgage/List'))
const Mortgagesigning = lazy(()=>import('../pages/Mortgage/Signing'))
const MortgageChannel = lazy(()=>import('../pages/Mortgage/Channel'))
const MortgageClient = lazy(()=>import('../pages/Mortgage/Client')) 
const MortgageHousing = lazy(()=>import('../pages/Mortgage/Housing')) 
const MortgageRebate = lazy(()=>import('../pages/Mortgage/Rebate')) 
const MortgageBystages = lazy(()=>import('../pages/Mortgage/Bystages')) 
const MortgageOnline = lazy(()=>import('../pages/Mortgage/Online'))
const MortgageMap = lazy(()=>import('../pages/Mortgage/Map'))
const MortgageLog = lazy(()=>import('../pages/Mortgage/Log'))
const MortgageSummary = lazy(()=>import('../pages/Mortgage/Summary'))
const MortgageSupervision = lazy(()=>import('../pages/Mortgage/Supervision'))

const Products = lazy(()=>import('../pages/Applet/Ysb/Product'))
const YsbUser = lazy(()=>import('../pages/Applet/Ysb/User'))
const YsbList = lazy(()=>import('../pages/Applet/Ysb/List'))
const YsbRebate = lazy(()=>import('../pages/Applet/Ysb/Rebate'))
const YsbPayment = lazy(()=>import('../pages/Applet/Ysb/Payment'))

const Ad = lazy(()=>import('../pages/Applet/Bhl/Ad'))
const Integrals = lazy(()=>import('../pages/Applet/Bhl/Integral'))
const Allocation = lazy(()=>import('../pages/Applet/Bhl/Allocation'))
const Appcode = lazy(()=>import('../pages/Applet/Bhl/Appcode'))
const Designer = lazy(()=>import('../pages/Applet/Bhl/Designer'))
const House = lazy(()=>import('../pages/Applet/Bhl/House'))
const Recommend = lazy(()=>import('../pages/Applet/Bhl/Recommend'))
const Complain = lazy(()=>import('../pages/Applet/Bhl/Complain'))

const Testdrive = lazy(()=>import('../pages/Activity/Testdrive'))
const TestdriveList = lazy(()=>import('../pages/Activity/List'))



const FinanceChannel = lazy(()=>import('../pages/Finance/Channel'))
const FinancePact = lazy(()=>import('../pages/Finance/Pact'))
const FinanceBalance = lazy(()=>import('../pages/Finance/Balance'))
const FinancePrestore = lazy(()=>import('../pages/Finance/Prestore'))
const FinanceSubsidy = lazy(()=>import('../pages/Finance/Subsidy'))
const FinanceApproval = lazy(()=>import('../pages/Finance/Approval'))

const Account = lazy(()=>import('../pages/System/Account'))
const Corp = lazy(()=>import('../pages/System/Corp'))
const City = lazy(()=>import('../pages/System/City'))
const Role = lazy(()=>import('../pages/System/Role'))
const Privilege = lazy(()=>import('../pages/System/Privilege'))
const Employee = lazy(()=>import('../pages/System/Employee'))
const OperationLog = lazy(()=>import('../pages/System/Log'))



// const Qrcode = lazy(()=>import('../pages/Applet/Qrcode'))





const Type = lazy(()=>import('../pages/Questions/Type'))
const Classify = lazy(()=>import('../pages/Questions/Classify'))
const Problem = lazy(()=>import('../pages/Questions/Problem'))


//网站管理
const WebsiteArticle = lazy(()=>import('../pages/Website/Article'))
const WebsiteVitae = lazy(()=>import('../pages/Website/Vitae'))
const WebsiteWork = lazy(()=>import('../pages/Website/Work'))



const routes = [
  {
    path:'/',
    element:<Navigate to="/index"/>
  },
  {
    path:'/login',
    element:<Login/>
  },
  {
    path:'/index',
    element:<Index/>,
    children:[
      {
        path:'chart',
        element:<Chart/>
      }
    ]
  },

  //客户中心
  {
    path:'/member',
    element:<Member/>,
    children:[
      {
        path:'list',
        element:<Client/>
      },
      {
        path:'calculate',
        element:<Calculate/>
      },
      {
        path:'calculates',
        element:<Calculates/>
      },
      {
        path:'confirm',
        element:<Confirm/>
      },
      {
        path:'rakeback',
        element:<Rakeback/>
      },
      {
        path:'information',
        element:<Information/>
      },
      {
        path:'proofs',
        element:<Proofs/>
      },
    ]
  },

  //用户建档
  {
    path:'/archive',
    element:<Archive/>,
    children:[
      {
        path:'userlist',
        element:<Userlist/>
      },
      {
        path:'integral',
        element:<Integral/>
      }
    ]
  },

  //渠道进件
  {
    path:'/outside',
    element:<Outside/>,
    children:[
      {
        path:'client',
        element:<OutsideClient/>
      },
      {
        path:'user',
        element:<OutsideUser/>
      }
    ]
  },

  //产品中心
  {
    path:'/product',
    element:<Product/>,
    children:[
      {
        path:'bank',
        element:<Bank/>,
      },
      {
        path:'list',
        element:<ProductList/>
      },
      {
        path:'channel',
        element:<Channel/>
      },
      {
        path:'source',
        element:<Source/>
      }
    ]
  },

  //考试管理
  {
    path:'/exam',
    element:<Exam/>,
    children:[
      {
        path:'paper',
        element:<Paper/>
      },
      {
        path:'question',
        element:<Question/>
      },
      {
        path:'reference',
        element:<Reference/>
      }
    ]
  },

  //房贷管理
  {
    path:'/mortgage',
    element:<Mortgage/>,
    children:[
      {
        path:'user',
        element:<MortgageUser/>
      },
      {
        path:'list',
        element:<MortgageList/>
      },
      {
        path:'bystages',
        element:<MortgageBystages/>
      },
      {
        path:'signing',
        element:<Mortgagesigning/>
      },
      {
        path:'Channel',
        element:<MortgageChannel/>
      },
      {
        path:'Client',
        element:<MortgageClient/>
      },
      {
        path:'Housing',
        element:<MortgageHousing/>
      },
      {
        path:'Rebate',
        element:<MortgageRebate/>
      },
      {
        path:'Online',
        element:<MortgageOnline/>
      },
      {
        path:'Map',
        element:<MortgageMap/>
      },
      {
        path:'Supervision',
        element:<MortgageSupervision/>
      },
      {
        path:'log',
        element:<MortgageLog/>
      },
      {
        path:'summary',
        element: <MortgageSummary/>
      }
    ]
  },

 
  //小程序
  {
    path:'/applet',
    element:<Applet/>,
    children:[
      {
        path:'product',
        element:<Products/>
      },
      {
        path:'ysbuser',
        element:<YsbUser/>
      },
      {
        path:'ysblist',
        element:<YsbList/>
      },
      {
        path:'ysbrebate',
        element:<YsbRebate/>
      },
      {
        path:'ysbpayment',
        element:<YsbPayment/>
      },
      {
        path:'Ad',
        element:<Ad/>
      },
      {
        path:'Integrals',
        element:<Integrals/>
      },
      {
        path:'Allocation',
        element:<Allocation/>
      },
      {
        path:'appcode',
        element:<Appcode/>
      },
      {
        path:'designer',
        element:<Designer/>
      },
      {
        path:'house',
        element: <House/>
      },
      {
        path:'recommend',
        element:<Recommend/>
      },
      {
        path:'complain',
        element: <Complain/>
      }
    ]
  },

  //小意问答
  {
    path:'/questions',
    element:<Questions/>,
    children:[
      {
        path:'type',
        element:<Type/>
      },
      {
        path:'classify',
        element:<Classify/>
      },
      {
        path:'problem',
        element:<Problem/>
      },
    ]
  },


  //活动管理
  {
    path:'/activity',
    element:<Activity/>,
    children:[
      {
        path:'Testdrive',
        element:<Testdrive/>
      },
      {
        path:'list',
        element:<TestdriveList/>
      }
    ]
  },

   //财务管理
  {
    path:'/finance',
    element:<Finance/>,
    children:[
      {
        path:'Channel',
        element:<FinanceChannel/>
      },
      {
        path:'Pact',
        element:<FinancePact/>
      },
      {
        path:'Balance',
        element:<FinanceBalance/>
      },
      {
        path:'Prestore',
        element:<FinancePrestore/>
      },
      {
        path:'Subsidy',
        element:<FinanceSubsidy/>
      },
      {
        path:'Approval',
        element: <FinanceApproval/>
      }
    ]
  },


  //系统设置
  {
    path:'/system',
    element:<System/>,
    children:[
      {
        path:'account',
        element:<Account/>
      },
      {
        path:'corp',
        element:<Corp/>
      },
      {
        path:'city',
        element:<City/>
      },
      {
        path:'role',
        element:<Role/>
      },
      {
        path:'privilege',
        element:<Privilege/>
      },
      {
        path:'employee',
        element:<Employee/>
      },
      {
        path:'log',
        element:<OperationLog/>
      }
    ]
  }, 

  //网站管理
  {
    path:'/website',
    element:<Website/>,
    children:[
      {
        path:'article',
        element:<WebsiteArticle/>
      },
      {
        path:'vitae',
        element:<WebsiteVitae/>
      },
      {
        path:'work',
        element:<WebsiteWork/>
      }
    ]
  },
]

export default routes